var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "telephonic-screening" }, [
    _c("div", { staticClass: "grid-x grid-padding-x" }, [
      _c(
        "div",
        {
          staticClass: "cell small-6",
          staticStyle: {
            "border-right": "solid 1px #D1D1D1",
            padding: "30px 35px"
          }
        },
        [
          _c("div", { staticStyle: { width: "90%" } }, [
            _c(
              "form",
              {
                ref: "panelInterviewForm",
                staticClass: "pt-0",
                attrs: { method: "post" }
              },
              [
                _c("input", {
                  attrs: { type: "hidden", name: "_csrfToken" },
                  domProps: { value: _vm.csrfToken }
                }),
                _vm._v(" "),
                _c("strong", [_vm._v("Onboarding Invitation")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Invite candidate to an orboarding session. Please specify the details of the boarding session\n                        below:"
                  )
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("strong", [_vm._v("Date & Time")]),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    disabled: _vm.disabled,
                    type: "datetime-local",
                    name: "job_offer[onboarding_datetime]",
                    required: ""
                  },
                  domProps: {
                    value: _vm.jobApplication.job_offer
                      ? _vm.convertDate(
                          _vm.jobApplication.job_offer.onboarding_datetime
                        )
                      : _vm.convertDate(this.value)
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("strong", [_vm._v("Venue/ location")]),
                _vm._v(" "),
                _c("textarea", {
                  attrs: {
                    disabled: _vm.disabled,
                    name: "job_offer[venue]",
                    required: ""
                  },
                  domProps: {
                    value: _vm.jobApplication.job_offer
                      ? _vm.jobApplication.job_offer.venue
                      : ""
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("strong", [_vm._v("Google maps link ")]),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    disabled: _vm.disabled,
                    type: "text",
                    name: "job_offer[google_maps_link]",
                    required: ""
                  },
                  domProps: {
                    value: _vm.jobApplication.job_offer
                      ? _vm.jobApplication.job_offer.google_maps_link
                      : ""
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("strong", [_vm._v("Contact Person")]),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    type: "text",
                    name: "job_offer[contact_person]",
                    required: ""
                  },
                  domProps: {
                    value: _vm.jobApplication.job_offer
                      ? _vm.jobApplication.job_offer.contact_person
                      : ""
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("strong", [_vm._v("Contact Number")]),
                _vm._v(" "),
                _c("input", {
                  attrs: {
                    type: "text",
                    name: "job_offer[contact_number]",
                    required: ""
                  },
                  domProps: {
                    value: _vm.jobApplication.job_offer
                      ? _vm.jobApplication.job_offer.contact_number
                      : ""
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("strong", [_vm._v("Other Notes")]),
                _vm._v(" "),
                _c("RedactorControlVue", {
                  attrs: {
                    name: "job_offer[notes]",
                    value: _vm.jobApplication.job_offer
                      ? _vm.jobApplication.job_offer.notes
                      : ""
                  }
                }),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("div", { staticClass: "grid-x grid-padding-x" }, [
                  _c("div", { staticClass: "cell shrink" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button",
                        attrs: {
                          disabled: _vm.disabled,
                          name: "send-offer",
                          type: "submit"
                        }
                      },
                      [_vm._v("Send")]
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "cell shrink" }, [
                    _c(
                      "button",
                      {
                        staticClass: "button",
                        attrs: {
                          disabled: _vm.disabled,
                          name: "send-offer-manually",
                          type: "submit"
                        }
                      },
                      [_vm._v("Set time manually")]
                    )
                  ])
                ])
              ],
              1
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "cell small-6 p-4" }, [
        _c(
          "div",
          { staticClass: "small-12" },
          [
            _c(
              "form",
              {
                ref: "panelInterviewForm",
                attrs: { method: "post" },
                on: { submit: _vm.disablePassBtn }
              },
              [
                _c("div", { staticStyle: { width: "90%" } }, [
                  _c("input", {
                    attrs: { type: "hidden", name: "_csrfToken" },
                    domProps: { value: _vm.csrfToken }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: { type: "hidden", name: "fail_reason" },
                    domProps: { value: _vm.fail_reason }
                  }),
                  _vm._v(" "),
                  _c("input", {
                    attrs: { type: "hidden", name: "loading_offer_status" },
                    domProps: { value: _vm.loading_offer_status }
                  }),
                  _vm._v(" "),
                  _c("h4", [_vm._v("Invitation")]),
                  _vm._v(" "),
                  _vm.jobApplication.job_offer
                    ? _c("div", [
                        _c("strong", [_vm._v("Invitation Status:")]),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.jobApplication.job_offer.status ===
                                "reschedule"
                                ? "The candidate is not available.  Please resend a new invitation."
                                : _vm.jobApplication.job_offer.status
                            ) +
                            "\n                                "
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("strong", [_vm._v("Date and Time Scheduled:")]),
                        _vm._v(
                          _vm._s(
                            _vm.jobApplication.job_offer.onboarding_datetime
                              ? _vm.convertDate(
                                  _vm.jobApplication.job_offer
                                    .onboarding_datetime,
                                  "MMMM D, YYYY H:mm"
                                )
                              : ""
                          ) + "\n                                "
                        ),
                        _c("br")
                      ])
                    : _c("div", [
                        _c("strong", [_vm._v("Invitation Status:")]),
                        _vm._v(
                          " Not yet sent\n                                "
                        ),
                        _c("br"),
                        _vm._v(" "),
                        _c("strong", [_vm._v("Date and Time Scheduled:")]),
                        _vm._v(
                          " Not yet set\n                                "
                        ),
                        _c("br")
                      ]),
                  _vm._v(" "),
                  _c("strong", [_vm._v("Final Status:")]),
                  _vm._v(
                    " " +
                      _vm._s(_vm.jobApplication.loading_offer_status) +
                      "\n                            "
                  ),
                  _vm.logs !== null && _vm.logs !== ""
                    ? _c("span", [
                        _vm._v(
                          "\n                                 (Updated By " +
                            _vm._s(_vm.logs.user.first_name) +
                            " " +
                            _vm._s(_vm.logs.user.last_name) +
                            " - " +
                            _vm._s(
                              _vm.convertDate(
                                _vm.logs.created,
                                "YYYY-MM-DD HH:mm"
                              )
                            ) +
                            ")\n                            "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "grid-x grid-padding-x" }, [
                    _c("div", { staticClass: "cell shrink" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button px-5",
                          attrs: {
                            type: "submit",
                            disabled: _vm.passBtnDisabled || _vm.disabled
                          }
                        },
                        [_vm._v("Pass")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("button", {
                        ref: "failedButton",
                        staticClass: "d-none",
                        attrs: { value: "failed", name: "loading_offer_status" }
                      }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "button alert px-5",
                          attrs: { disabled: _vm.disabled, type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.toggleModal("failModal")
                            }
                          }
                        },
                        [_vm._v("Fail")]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "cell shrink" }, [
                      _c(
                        "button",
                        {
                          staticClass: "button recycle px-5",
                          attrs: { disabled: _vm.disabled, type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.toggleModal("recycleModal")
                            }
                          }
                        },
                        [_vm._v("Recycle")]
                      )
                    ])
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c("fail-modal", {
              ref: "failModal",
              attrs: { "job-application": _vm.jobApplication },
              on: { submit: _vm.fail }
            }),
            _vm._v(" "),
            _c("recycle-modal", {
              ref: "recycleModal",
              attrs: {
                "job-application": _vm.jobApplication,
                "csrf-token": _vm.csrfToken
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm.sageLog
          ? _c("div", { staticClass: "small-12 mt-5" }, [
              _c("label", { staticClass: "fw-bold" }, [
                _vm._v("Sage sync status:")
              ]),
              _c("br"),
              _vm._v(" "),
              _vm.sageLog.completed
                ? _c("span", { staticClass: "text-green" }, [_vm._v("Synced")])
                : _vm._e(),
              _vm._v(" "),
              !_vm.sageLog.completed && _vm.sageLog.failed > 0
                ? _c("span", { staticClass: "text-red" }, [_vm._v("Failed")])
                : _vm._e(),
              _vm._v(" "),
              !_vm.sageLog.completed &&
              _vm.sageLog.failed > 0 &&
              _vm.sageLog.log_entries[0]
                ? _c("div", { staticClass: "mt-4" }, [
                    _vm.sageLog.log_entries[0].response_data.includes("{")
                      ? _c("div", [
                          _c("label", { staticClass: "fw-bold" }, [
                            _vm._v("Parsed Sage Response:")
                          ]),
                          _c("br"),
                          _vm._v(" "),
                          _c(
                            "ul",
                            _vm._l(
                              _vm.parseSageResponse(
                                "{" +
                                  _vm.sageLog.log_entries[0].response_data
                                    .split("{")
                                    .slice(1)
                                    .join("{")
                              ).businessRules,
                              function(rule) {
                                return _c("li", { key: rule.PropertyName }, [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(rule.PropertyFriendlyName) +
                                      "\n                                "
                                  ),
                                  rule.WarningRulesCollection
                                    ? _c(
                                        "ul",
                                        _vm._l(
                                          rule.WarningRulesCollection,
                                          function(message) {
                                            return _c("li", { key: message }, [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(message.Message) +
                                                  "\n                                    "
                                              )
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  rule.ErrorRulesCollection
                                    ? _c(
                                        "ul",
                                        _vm._l(
                                          rule.ErrorRulesCollection,
                                          function(message) {
                                            return _c("li", { key: message }, [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(message.Message) +
                                                  "\n                                    "
                                              )
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e()
                                ])
                              }
                            ),
                            0
                          ),
                          _vm._v(" "),
                          _c("br")
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("label", { staticClass: "fw-bold" }, [
                      _vm._v("Error Response:")
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _vm.sageLog.log_entries[0].response_data.includes("{")
                      ? _c("div", [
                          _c("pre", [
                            _vm._v(
                              _vm._s(
                                "{" +
                                  _vm.sageLog.log_entries[0].response_data
                                    .split("{")
                                    .slice(1)
                                    .join("{")
                              )
                            )
                          ])
                        ])
                      : _c("div", [
                          _c("pre", [
                            _vm._v(
                              _vm._s(_vm.sageLog.log_entries[0].response_data)
                            )
                          ])
                        ]),
                    _vm._v(" "),
                    _c("div", [
                      _c("label", { staticClass: "fw-bold" }, [
                        _vm._v("Payload Sent:")
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("pre", [
                        _vm._v(_vm._s(_vm.sageLog.log_entries[0].request_data))
                      ])
                    ])
                  ])
                : _vm._e()
            ])
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-65e2cb7d", { render: render, staticRenderFns: staticRenderFns })
  }
}